import { createReducer } from '@reduxjs/toolkit';

import { CONTRACT_AUTHENTICATION_INITIALIZE } from '@app/store/actionTypes';
import {
  fetchContractAuthentication,
  fetchMessageFromRequester,
} from '@app/store/contract-authentication/actions';

export type ContractAuthenticationParticipantIdState = string | null;

const initialState: ContractAuthenticationParticipantIdState = null;

const reducer = createReducer<ContractAuthenticationParticipantIdState>(initialState, (builder) =>
  builder
    .addCase(fetchMessageFromRequester.pending, (_, action) => action.meta.arg.participantId)
    .addCase(fetchContractAuthentication.pending, (_, action) => action.meta.arg.participantId)
    .addCase(CONTRACT_AUTHENTICATION_INITIALIZE, () => initialState)
);

export default reducer;
